export default {
    position: {
        bottom: 0,
        right: 0,
    },
    event: 'click',

    mainButtonStyles: {
        backgroundColor: '#24B0A6',
        fill: '#ffffff',
        transform: 'none',
        transition: 'none',
        transformOrigin: 'none',
    },
    alwaysShowTitle: false,
    actionButtonStyles: {
        backgroundColor: '#19837C',
    }
}
